import {svgIconWrapper} from '../svg-icon-wrapper';

import SignNowRegular from './sign-now-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <SignNowRegular {...props} />;
}

SvgComponent.iconName = 'signNowRegular';

export const SignNowRegularIcon = svgIconWrapper(SvgComponent);
